import SamsungRacing from "@/features/samsung-racing/pages/samsungRacing";
import Loader from "@/components/ui/Loader/Loader";
import { RouteObject } from "react-router-dom";
import { Flex } from "@radix-ui/themes";
import { lazy, Suspense } from "react";

import { siteRoutes } from "../siteRoutes";

const TypingShooter = lazy(
  () => import("@/features/typing-shooter/pages/typingShooterPage"),
);
const KeychronTimeTrail = lazy(
  () => import("@/features/keychron-time-trail/pages/keychronTimeTrailPage"),
);
const Cs2PageVertical = lazy(
  () => import("@/features/cs2-timed-vertical/pages/Cs2Page"),
);
const RacingPagV2 = lazy(
  () => import("@/features/racedays/pages/default/RacingPage"),
);
const RacingPage = lazy(
  () => import("@/features/racing/pages/default/RacingPage"),
);
const Cs2Page = lazy(
  () => import("@/features/cs2-timed/pages/default/Cs2Page"),
);
const TclCs2Page = lazy(
  () => import("@/features/cs2-timed/pages/default/TclCs2Page"),
);
const SamsungPage = lazy(
  () => import("@/features/samsung/pages/SamsungPage"),
);
const ListPage = lazy(() => import("@/features/list/pages/ListPage"));

const fallback = (
  <Flex align={"center"} justify={"center"} width={"100vw"} height={"100vh"}>
    <Loader />
  </Flex>
);

export const clientRouteConfigs: RouteObject[] = [
  {
    path: siteRoutes.elgiganten.f1.path,
    element: (
      <Suspense fallback={fallback}>
        <RacingPage />
      </Suspense>
    ),
  },
  {
    path: siteRoutes.logitech.fm.path,
    element: (
      <Suspense fallback={fallback}>
        <RacingPage />
      </Suspense>
    ),
  },
  {
    path: siteRoutes.racedays.fm.path,
    element: (
      <Suspense fallback={fallback}>
        <RacingPagV2 />
      </Suspense>
    ),
  },
  {
    path: siteRoutes.legof1.f1.path,
    element: (
      <Suspense fallback={fallback}>
        <RacingPage />
      </Suspense>
    ),
  },
  {
    path: siteRoutes.legobtp.f1.path,
    element: (
      <Suspense fallback={fallback}>
        <RacingPage />
      </Suspense>
    ),
  },
  {
    path: siteRoutes.tcltt.tt.path,
    element: (
      <Suspense fallback={fallback}>
        <TclCs2Page />
      </Suspense>
    ),
  },
  {
    path: siteRoutes.jbltt.tt.path,
    element: (
      <Suspense fallback={fallback}>
        <Cs2Page />
      </Suspense>
    ),
  },
  {
    path: siteRoutes.keychrontt.tt.path,
    element: (
      <Suspense fallback={fallback}>
        <Cs2Page />
      </Suspense>
    ),
  },
  {
    path: siteRoutes.keychrontt.ttv.path,
    element: (
      <Suspense fallback={fallback}>
        <Cs2PageVertical />
      </Suspense>
    ),
  },
  {
    path: siteRoutes.keychrontt.ts.path,
    element: (
      <Suspense fallback={fallback}>
        <TypingShooter />
      </Suspense>
    ),
  },
  {
    path: siteRoutes.keychrontt.timetrial.path,
    element: (
      <Suspense fallback={fallback}>
        <KeychronTimeTrail />
      </Suspense>
    ),
  },
  {
    path: siteRoutes.keychrontt["samsung-racing"].path,
    element: (
      <Suspense fallback={fallback}>
        <SamsungRacing />
      </Suspense>
    ),
  },
  {
    path: siteRoutes.samsung.base.path,
    element: (
      <Suspense fallback={fallback}>
        <SamsungPage />
      </Suspense>
    ),
  },
  {
    path: siteRoutes.list.path,
    element: (
      <Suspense fallback={fallback}>
        <ListPage />
      </Suspense>
    ),
  },
];
